import React from 'react';
import { GlassesIcon } from 'lucide-react';
import { lenses, media } from '../data/product';
import { GuaranteeBadge, GuaranteeStrip, ShopHotspot } from './BannerOverlays';
import { CtaButton } from './CtaButton';
import { deepLinkClick } from '../utils/deepLinks';
export function LensSection() {
  return <section id="lenses" className="scroll-mt-28 border-b border-white/10 bg-ink-900" data-id="element-686" data-mp="3biyfkuc29ghn">
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-687" data-mp="2wuboxwgzh2b4">
        <h2 className="grit-headline text-[clamp(2.75rem,11vw,6rem)] font-extrabold uppercase text-offwhite" data-id="element-688" data-mp="31lk315t9dbum">
          One frame.
          <br data-id="element-689" data-mp="2nv87ewxgsuyq" />
          <span className="text-grit-500" data-id="element-690" data-mp="2nvgn0wkz2edm">Three lenses.</span>
        </h2>
        <p className="mt-4 text-lg font-medium text-steel-300 sm:text-xl" data-id="element-691" data-mp="2ssgsb59zzd3o">Change the lens. Keep working.</p>

        <figure className="relative mt-10" data-id="element-692" data-mp="2dx0tkmyh2t0y">
          <img src={media.lensSheet} alt="GritVue X1 shown with its clear, amber and smoke interchangeable lenses and workers using each one" className="block h-auto w-full border border-white/10" data-id="element-693" data-mp="2dybveh8cxqpf" />
          <GuaranteeBadge box={{
          left: '16.9%',
          top: '43.9%',
          width: '18.4%',
          height: '11.2%'
        }} data-id="element-694" data-mp="392am3x04106x" />
          <ShopHotspot box={{
          left: '3.5%',
          top: '46.2%',
          width: '14%',
          height: '7.2%'
        }} data-id="element-695" data-mp="3n1k3v13ys2d0" />
          <GuaranteeStrip className="mt-0" data-id="element-696" data-mp="3iz5hi7136kgz" />
        </figure>

        <ul className="mt-6 grid gap-6 lg:grid-cols-3" data-id="element-697" data-mp="3ixuhmiarhwv5">
          {lenses.map(lens => <li key={lens.name} className="flex h-full flex-col border border-white/10 bg-ink-950 p-6" data-id="element-698" data-mp="2v807i8htumel">
              <span className="h-14 w-24 rounded-[999px_999px_60px_60px] border-2 border-white/25" style={{
            backgroundColor: lens.swatch
          }} aria-hidden="true" data-id="element-699" data-mp="2q96pc2rli783" />
              <h3 className="mt-6 font-display text-4xl font-extrabold uppercase leading-none text-offwhite" data-id="element-700" data-mp="2blvgi8mst1bo">
                {lens.name}
              </h3>
              <p className="mt-2 text-xs font-bold uppercase tracking-[0.2em] text-grit-500" data-id="element-701" data-mp="27k9wm3bujmrz">{lens.use}</p>
              <p className="mt-3 text-[15px] text-steel-400" data-id="element-702" data-mp="aht9mo62c53u">{lens.body}</p>
            </li>)}
        </ul>

        <p className="mt-8 text-center font-display text-2xl font-bold uppercase tracking-wide text-offwhite" data-id="element-703" data-mp="k9p7pz85fv82">
          The full lens system comes with the Complete System and every multipack.
        </p>
        <p className="mt-2 text-center text-[15px] text-steel-400" data-id="element-704" data-mp="3nqfkqy25f8j9">
          Building an X1 Essential? Pick one lens, then add the other two for $9.95.
        </p>

        <a href="#rx" onClick={deepLinkClick('rx')} className="mt-8 flex flex-col items-start gap-4 border-2 border-grit-500 bg-grit-500/10 p-5 transition-colors duration-150 ease-grit hover:bg-grit-500/15 sm:flex-row sm:items-center sm:p-6" data-id="element-705" data-mp="3spr0q4uoy9zs">
          <GlassesIcon className="h-9 w-9 shrink-0 text-grit-500" aria-hidden="true" data-id="element-706" data-mp="1cxl4t51mrp5d" />
          <p data-id="element-707" data-mp="1hwej2zoqrk6l">
            <span className="block font-display text-2xl font-extrabold uppercase leading-none text-grit-500 sm:text-3xl" data-id="element-708" data-mp="1hvwar4ot1fib">
              Prescription ready
            </span>
            <span className="mt-1.5 block text-[15px] font-medium text-steel-200" data-id="element-709" data-mp="2xg5eqnfzvqdt">
              Available now: RX Capability Insert, +$14.95. See how it works →
            </span>
          </p>
        </a>

        <p className="grit-headline mt-12 text-center text-[clamp(2rem,7vw,4rem)] font-extrabold uppercase text-offwhite" data-id="element-710" data-mp="2npki35jvsvxj">
          One frame.
          <br data-id="element-711" data-mp="2ip66jdj2n3ur" />
          <span className="text-grit-500" data-id="element-712" data-mp="2epxgain8po3y">Every job.</span>
        </p>

        <div className="mt-8 flex justify-center" data-id="element-713" data-mp="2es0dbmmt8hi6">
          <CtaButton href="#build-your-x1" className="w-full sm:w-auto" data-id="element-714" data-mp="29q19kbn5rikp">
            Build your X1
          </CtaButton>
        </div>
      </div>
    </section>;
}